// extracted by mini-css-extract-plugin
export var button = "_jq-2";
export var card = "_jq-0";
export var closeButtonContainer = "_jq-3";
export var iconContainer = "_jq-1";